module.exports = __webpack_public_path__ + "media/images/question-circle-fill-60c2fbc8.svg";